export const EXPERIENCE_STATES = {
    published: 'published',
    draft: 'draft',
    deactivated: 'unpublished'
}